// extracted by mini-css-extract-plugin
export default {"sectionContainer":"src-pages-SalesCannelVersion-SalesChannelDiscounts-DirectDiscount-Detail-OrderEligible-css-module__sectionContainer--ed2j4"};